<template>
  <v-card
    flat
    class="vetalfa-card-grey-border vetalfa-pointer pa-0 timeline-card"
    style="border-left: 4px solid #193153; overflow: hidden"
    @click="open"
  >
    <v-row class="ma-0 pa-0" align="center" no-gutters>
      <v-col cols="auto" class="pa-3 d-flex align-center">
        <v-avatar size="36" color="#193153" class="white--text">
          <v-icon small color="white">{{ mdiStethoscope }}</v-icon>
        </v-avatar>
      </v-col>
      <v-col class="pa-3 pl-0">
        <p class="ma-0 subtitle-2 font-weight-bold">
          {{ typeLabel }}
        </p>
        <p class="ma-0 caption grey--text text--darken-1">
          {{ formattedDate }}
        </p>
        <p v-if="summaryText" class="ma-0 caption mt-1 text-truncate" style="line-height: 1.3; max-width: 400px">
          {{ summaryText }}
        </p>
        <div class="mt-1">
          <v-chip
            x-small
            :color="isFinished ? 'success' : 'grey lighten-2'"
            :text-color="isFinished ? 'white' : 'grey darken-2'"
          >
            {{ statusLabel }}
          </v-chip>
          <v-chip
            v-if="hasAddenda"
            x-small
            class="ml-1"
            color="blue lighten-4"
            text-color="blue darken-2"
          >
            {{ _getLabel("WITH_ADDENDUM") }}
          </v-chip>
          <v-chip
            v-if="encounter.doctorName"
            x-small
            class="ml-1"
            color="grey lighten-2"
            text-color="grey darken-2"
          >
            {{ encounter.doctorName }}
          </v-chip>
        </div>
        <p v-if="isFinished" class="ma-0 caption grey--text text--darken-1 mt-1">
          {{ _getLabel("FINALIZED_BY") }}: {{ signatureText }}
        </p>
      </v-col>
      <v-col cols="auto" class="pr-2">
        <v-icon x-small color="grey">{{ mdiChevronRight }}</v-icon>
      </v-col>
    </v-row>
  </v-card>
</template>

<script>
import { mdiChevronRight, mdiStethoscope } from "@mdi/js";
import encounters from "@/constants/encounters.enum.js";

export default {
  name: "EncounterCard",
  props: {
    encounter: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      mdiChevronRight,
      mdiStethoscope,
    };
  },
  computed: {
    formattedDate() {
      if (!this.encounter.date && !this.encounter.lastUpdate) return "-";
      return this._getDateFromTimestamp(
        this.encounter.date || this.encounter.lastUpdate
      );
    },
    typeLabel() {
      return encounters.getTypeLabel(this.encounter.type, this._getLabel);
    },
    statusLabel() {
      return encounters.getStatusLabel(
        this.isFinished ? encounters.STATUS.FINISHED : encounters.STATUS.IN_PROGRESS,
        this._getLabel
      );
    },
    /**
     * O estado vem da assinatura do servidor; `status` fica como compatibilidade
     * com as consultas finalizadas antes de `finalizedAt` existir.
     */
    isFinished() {
      return !!(
        this.encounter.finalizedAt ||
        this.encounter.status === encounters.STATUS.FINISHED
      );
    },
    hasAddenda() {
      return ((this.encounter.addenda || []).length || 0) > 0;
    },
    signatureText() {
      const author = this.encounter.finalizedBy || {};
      const name = [author.displayNamePrefix, author.displayName]
        .filter((part) => !!part)
        .join(" ");
      const crmv =
        author.crmvNumber || author.crmvState
          ? `CRMV ${author.crmvNumber || ""}${
              author.crmvState ? "-" + author.crmvState : ""
            }`.trim()
          : "";
      const date = this.encounter.finalizedAt
        ? new Date(this.encounter.finalizedAt).toLocaleString("pt-BR")
        : "";
      return [name, crmv, date].filter((part) => !!part).join(" • ") || "-";
    },
    summaryText() {
      return this.encounter.chiefComplaint || this.encounter.notes || '';
    },
  },
  methods: {
    open() {
      this.$emit("open", this.encounter);
    },
  },
};
</script>

<style scoped>
.timeline-card {
  background:#fff; border-color:#e5e9f1 !important; transition: box-shadow 0.2s, transform .2s;
}
.timeline-card:hover {
  box-shadow:0 6px 18px rgba(25,49,83,.12) !important; transform:translateY(-1px);
}
</style>
